﻿import { tns } from "tiny-slider"

window.tns = tns;

//export var slider = tns({
//    container: '.my-slider',
//    items: 3,
//    slideBy: 'page',
//    autoplay: true
//});

var companySlider;

function initCompanySlider() {

    let target = document.getElementById('company-banner-container');
    if (target) {
        companySlider = tns({
            container: '.customer-logos',
            speed: 1000,
            edgePadding: 50,
            center: false,
            autoWidth: false,
            autoHeight: true,
            gutter: 175,
            items: 7,            // Number of items to show by default
            slideBy: 3,          // Number of slides to scroll
            autoplay: true,      // Enable autoplay
            autoplayButtonOutput: false, // Disable autoplay controls
            controls: false,     // Disable next/prev arrows
            nav: false,          // Disable navigation dots
            mouseDrag: false,     // Allow dragging with mouse
            autoplayTimeout: 3500, // Autoplay speed in milliseconds
            responsive: {
                1536: {
                    items: 7        // Number of items to show on medium screens
                },
                1280: {
                    items: 5,         // Number of items to show on medium screens
                    autoHeight: true,
                },
                1024: {
                    items: 4,         // Number of items to show on medium screens
                    autoHeight: false,
                },
                640: {
                    items: 3,         // Number of items to show on medium screens
                    gutter: 100,
                    edgePadding: 60,
                    autoHeight: false,
                },
                0: {
                    edgePadding: 10,
                    gutter: 30,
                    items: 3,
                    autoHeight: false,
                }
            }
        });
    }
}

document.addEventListener('htmx:afterSettle', function () {
    initCompanySlider();
});

document.addEventListener('DOMContentLoaded', function () {
    initCompanySlider();
});